import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Supabase credentials not configured. Please update your .env file.",
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface DbUser {
  id: string;
  email: string;
  name: string;
  role: "user" | "admin";
  kyc_status: "pending" | "verified" | "rejected";
  is_verified: boolean;
  invested_amount: number;
  total_profit: number;
  total_bonus: number;
  created_at: string;
  updated_at: string;
}

export interface DbBalance {
  id: string;
  user_id: string;
  symbol: string;
  currency: string;
  amount: number;
  created_at: string;
  updated_at: string;
}

export interface DbTransaction {
  id: string;
  user_id: string;
  type:
    | "deposit"
    | "withdraw"
    | "buy"
    | "sell"
    | "admin_credit"
    | "admin_debit"
    | "withdrawal"
    | "swap_in"
    | "swap_out"
    | "investment"
    | "profit"
    | "bonus";
  symbol: string;
  currency: string;
  amount: number;
  price_usd: number;
  total_usd: number;
  fee: number;
  status: "pending" | "completed" | "failed";
  note: string | null;
  admin_id: string | null;
  created_at: string;
}

export interface DbInvestment {
  id: string;
  user_id: string;
  plan_name: string;
  symbol: string;
  currency: string;
  amount: number;
  amount_usd: number;
  roi_percent: number;
  duration_days: number;
  expected_return_usd: number;
  status: "active" | "matured" | "cancelled";
  started_at: string;
  matures_at: string;
  matured_at: string | null;
  created_at: string;
  updated_at: string;
  daily_accrual_rate: number;
  current_earnings_usd: number;
  admin_roi_override: number | null;
  admin_note: string | null;
  created_by: string;
  is_admin_created: boolean;
}

export interface DbPlatformWallet {
  id: string;
  symbol: string;
  currency: string;
  address: string;
  network: string;
  min_deposit: number;
  confirmations: number;
  is_active: boolean;
}

export interface DbUserWallet {
  id: string;
  user_id: string;
  label: string;
  symbol: string;
  address: string;
  network: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface DbKycDocument {
  id: string;
  user_id: string;
  full_name: string;
  date_of_birth: string;
  nationality: string;
  address: string;
  id_type: "passport" | "drivers_license" | "national_id";
  id_number: string;
  id_front_url: string | null;
  id_back_url: string | null;
  selfie_url: string | null;
  status: "pending" | "approved" | "rejected";
  admin_note: string | null;
  reviewed_by: string | null;
  reviewed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface DbNotification {
  id: string;
  user_id: string;
  title: string;
  message: string;
  type: "info" | "success" | "warning" | "error";
  read: boolean;
  action_type: string | null;
  related_id: string | null;
  created_at: string;
  updated_at: string;
}
